import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ButtonSubmit, Form } from '@anytag/shared-atoms';
import { PricingTableItem, TikTokSpecialCampaignStatus } from '@anytag/graphql';
import { TikTokCampaignFormValues } from './types';
import { LeaveWarningModal } from './LeaveWarningModal';
import { getTikTokCampaignDisabledFields } from './utils';
import { CampaignInformation, PackageInformation, PlanInformation } from './formSections';

export interface TemplateProps {
  onSubmit?: () => void;
  currentPlan?: PricingTableItem;
}
export const Template = ({ onSubmit, currentPlan }: TemplateProps) => {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    formState: { isSubmitting }
  } = useFormContext<TikTokCampaignFormValues>();

  const [isValue, isDraftValue, statusValue] = watch(['id', 'isDraft', 'status']);
  const disabledFields = getTikTokCampaignDisabledFields(statusValue);

  const handleSubmit =
    ({ isDraft, saveOnLeave }: Pick<TikTokCampaignFormValues, 'isDraft' | 'saveOnLeave'>) =>
    () => {
      setValue('isDraft', isDraft);
      setValue('saveOnLeave', saveOnLeave);
      onSubmit?.();
    };

  return (
    <>
      <Form.Body className="form-container">
        {currentPlan ? <PlanInformation currentPlan={currentPlan} /> : null}
        <PackageInformation disabledFields={disabledFields} />
        <CampaignInformation disabledFields={disabledFields} />
      </Form.Body>

      <Form.Footer>
        {statusValue === TikTokSpecialCampaignStatus.DRAFT && !!isValue && (
          <>
            <ButtonSubmit
              type="button"
              variant="outline"
              title={t('Button.Save as draft')}
              loading={isDraftValue && isSubmitting}
              onClick={handleSubmit({ isDraft: true, saveOnLeave: false })}
            />

            <LeaveWarningModal onSubmit={handleSubmit({ isDraft: true, saveOnLeave: true })} />
          </>
        )}

        <ButtonSubmit
          type="button"
          title={t('Button.Save')}
          loading={!isDraftValue && isSubmitting}
          onClick={handleSubmit({ isDraft: false, saveOnLeave: false })}
        />
      </Form.Footer>
    </>
  );
};
